import React from 'react';
import PropTypes from 'prop-types';
import { icons } from '~/tools/icons';
import { jss } from '~/tools/jss';
import { statuses } from '~/config/settings/notification.settings';
import SimpleDialog from './SimpleDialog';

const useStyles = jss.makeStyles((theme) => ({
  iconContainer: {
    width: 60,
    height: 60,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: 60,
  },
  info: {
    // @ts-expect-error TS(2339): Property 'legacyPalette' does not exist on type 'T... Remove this comment to see the full error message
    color: theme.legacyPalette.blue,
  },
  error: {
    // @ts-expect-error TS(2339): Property 'legacyPalette' does not exist on type 'T... Remove this comment to see the full error message
    color: theme.legacyPalette.red,
  },
  success: {
    // @ts-expect-error TS(2339): Property 'legacyPalette' does not exist on type 'T... Remove this comment to see the full error message
    color: theme.legacyPalette.green,
  },
  warning: {
    // @ts-expect-error TS(2339): Property 'legacyPalette' does not exist on type 'T... Remove this comment to see the full error message
    color: theme.legacyPalette.neutral,
  },
}));

const getStatusIcon = (status, styles) => {
  let StatusIcon;
  let statusStyles = null;

  switch (status) {
    case statuses.error:
      StatusIcon = icons.Error;
      statusStyles = styles.error;
      break;
    case statuses.warning:
      StatusIcon = icons.Warning;
      statusStyles = styles.warning;
      break;
    case statuses.success:
      StatusIcon = icons.CheckCircle;
      statusStyles = styles.success;
      break;
    case statuses.info:
    default:
      StatusIcon = icons.Info;
      statusStyles = styles.info;
  }

  return () => (
    <div className={jss.combineStyles(styles.iconContainer, statusStyles)}>
      <StatusIcon className={jss.combineStyles(styles.icon, statusStyles)} />
    </div>
  );
};

// Because this is a global component that could be on top of any part of
// the app, it tracks its state in the redux store so other components can
// transmit content data to it.
//
// REFACTOR: the default values set here, override the default values for
// the lower level SimpleDialog. This has unintended consequences if the user
// only wants the default (which default is the default?)
const StatusDialog = ({
  title = '',
  message = '',
  status = statuses.info,
  isVisible = false,
  onClose = () => {},
  onConfirm = () => {},
  closeButtonLabel = 'button.ok', // REFACTOR: would rather this be a plain string than a POEditor key
  allowCancel = false,
  cancelButtonLabel = 'button.cancel',
}) => {
  // @ts-expect-error TS(2339): Property 'propTypes' does not exist on type '({ ti... Remove this comment to see the full error message
  StatusDialog.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    status: PropTypes.oneOf(Object.values(statuses)),
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    closeButtonLabel: PropTypes.string,
    allowCancel: PropTypes.bool,
    cancelButtonLabel: PropTypes.string,
  };
  const styles = useStyles();
  const Icon = getStatusIcon(status, styles);

  return (
    <SimpleDialog
      title={title}
      message={message}
      isVisible={isVisible}
      onClose={onClose}
      onConfirm={onConfirm}
      closeButtonLabel={closeButtonLabel}
      allowCancel={allowCancel}
      cancelButtonLabel={cancelButtonLabel}
      // @ts-expect-error TS(2322): Type '() => JSX.Element' is not assignable to type... Remove this comment to see the full error message
      Icon={Icon}
    />
  );
};

export default StatusDialog;
